import styled, { css } from 'styled-components';
import Split from 'react-split';

import { colors } from 'global/colors';

export const ResizableColumnsContainer = styled(Split)`
  height: 100%;
  display: flex;
  flex-direction: row;

  & .gutter.gutter-horizontal {
    cursor: col-resize;
    ${({ splitdarkmode }) =>
      css`
        background-color: ${splitdarkmode ? colors.black : colors.lightGray};
      `};
    :hover {
      background-color: ${colors.fsCyan};
    }
  }
`;

export const ColumnContainer = styled.div`
  overflow: hidden;
  height: 100%;
  width: 100%;
`;
